import { MapComponents } from '@components/BlockMapper';
import { kebabCase } from 'lodash';
import { FC } from 'react';

export interface AboutSectionProps {
  aboutContent: any;
}

const AboutSection: FC<AboutSectionProps> = ({ aboutContent }) => {
  const aboutData = aboutContent
    ? [
        {
          ...aboutContent,
          className: aboutContent?.sys?.contentType?.sys?.id
            ? `${kebabCase(aboutContent?.sys?.contentType?.sys?.id)}-cn`
            : null,
        },
      ]
    : [];

  if (aboutData.length) {
    return <MapComponents blocks={aboutData} key={aboutContent[0]?.sys?.id} />;
  }
};

export default AboutSection;
